// extracted by mini-css-extract-plugin
module.exports = {"app":"App_app__2ziFi","header":"App_header__2L3DO"};